__turbopack_context__.v({
  "accordionSlideOverwrite": "downloadBanner-module-scss-module__g8buRq__accordionSlideOverwrite",
  "badge": "downloadBanner-module-scss-module__g8buRq__badge",
  "badges": "downloadBanner-module-scss-module__g8buRq__badges",
  "banner": "downloadBanner-module-scss-module__g8buRq__banner",
  "copy": "downloadBanner-module-scss-module__g8buRq__copy",
  "description": "downloadBanner-module-scss-module__g8buRq__description",
  "fadeIn": "downloadBanner-module-scss-module__g8buRq__fadeIn",
  "fadeOut": "downloadBanner-module-scss-module__g8buRq__fadeOut",
  "phone": "downloadBanner-module-scss-module__g8buRq__phone",
  "phoneLong": "downloadBanner-module-scss-module__g8buRq__phoneLong",
  "scaleIn": "downloadBanner-module-scss-module__g8buRq__scaleIn",
  "scaleOut": "downloadBanner-module-scss-module__g8buRq__scaleOut",
  "starCluster": "downloadBanner-module-scss-module__g8buRq__starCluster",
  "title": "downloadBanner-module-scss-module__g8buRq__title",
  "visual": "downloadBanner-module-scss-module__g8buRq__visual",
  "zoomIn": "downloadBanner-module-scss-module__g8buRq__zoomIn",
  "zoomOut": "downloadBanner-module-scss-module__g8buRq__zoomOut",
});
